import { CATEGORY, type Category } from './category';

export function CategoryTag({ category, label }: { category: Category; label?: string }) {
  const c = CATEGORY[category];
  return (
    <span className={`wb-cattag ${c.cls}`}>
      <span className="wb-dot" />
      {label ?? c.label}
    </span>
  );
}
